<template>
	<CharacteristicEdit
		v-model="organisationalArea"
		ref="edit"
		:title="title"
		:with-keyword="true"
		keyword-placeholder="Organisationsbereich eingeben (mind. 3 Zeichen)"
		:characteristic-type="meta.organisationalAreaType"
		:characteristic-items="characteristicItems"
		:nothing-allowed="nothingAllowed ? {
			overall: {
				inFan: true,
				text: 'Es sind alle Organisationsbereiche möglich'
			}
		} : undefined"
		:title-formats="{
			default: 'Welchen Organisationsbereich im Bereich<br />%characteristicLabel%?',
			level: {
				1: title,
			}
		}"
		show-multiple-hint
		open-fan-label="Organisationsbereiche auswählen"
		open-fan-label-with-selection="Organisationsbereiche bearbeiten"
		label-type="application"
		:with-edit-button="withEditButton"
		:open-fan-button-alignment="buttonAlignment"
		@input="$emit('input', $event)"
	/>
</template>

<script>
import CharacteristicEdit from "@/vue/characteristic/Edit.vue";
import {mapState} from "vuex";
import {filterItems} from "@/helper/characteristic/OrganisationalArea";

export default {

	components: {
		CharacteristicEdit
	},

	props: {
		value: {
			type: Array,
			required: false,
		},
		withEditButton: {
			type: Boolean,
			required: false,
			default: true,
		},
		buttonAlignment: {
			type: String,
			required: false
		},
		nothingAllowed: {
			type: Boolean,
			required: false,
			default: true,
		},
		functions: {
			type: Array,
			required: true
		}
	},

	data ()
	{
		return {
			organisationalArea: this.value
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		title ()
		{
			return 'Organisationsbereich:<br/>' +
				'Wähle die gewünschten Organisationsbereiche, in denen du deine Tätigkeit ausführen willst.'
		},
		characteristicItems ()
		{
			return filterItems(this.meta, this.functions);
		}
	},

	watch: {
		value (v)
		{
			this.organisationalArea = v;
		}
	}
}
</script>
